import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48730a7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-form" }
const _hoisted_2 = { class: "task-form__fields" }

import { computed, ref, watch } from 'vue';

import DSTextField from '@/design-system/DSTextField.vue';
import DSSelect from '@/design-system/DSSelect.vue';
import Timer from './Timer.vue';

import { useStore } from '@/store';
import {
  CREATE_NEW_TASK,
  FETCH_PROJECTS,
  FINISH_TASK_SESSION,
} from '@/store/types/actions';
import { NEW_ACTIVE_TASK } from '@/store/types/mutations';

interface ProjectOption {
  label: string;
  value: number | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const store = useStore();
const description = ref('');
const project_id = ref<number | null>(null);
const projects = computed(() => store.state.project.projects);
const active_task = computed(() => store.state.task.active_task);
const playRequestPending = ref(false);
const stopRequestPending = ref(false);

store.dispatch(FETCH_PROJECTS);

const parsedProjects = computed<ProjectOption[]>(() => [
  { label: 'No project', value: null },
  ...projects.value.map((project) => ({
    label: project.name,
    value: project.id,
  })),
]);

const finishTask = async (): Promise<void | boolean> => {
  stopRequestPending.value = true;
  await handleFinishTask();

  return stopRequestPending.value = false;
};

const handleFinishTask = async () => {
  const project = projects.value.find(project => project.id === project_id.value);
  const task_name = description.value;

  description.value = '';
  project_id.value = null;

  if (active_task.value.id) {
    await store.dispatch(FINISH_TASK_SESSION, active_task.value);

    return store.commit(NEW_ACTIVE_TASK, {});
  }

  await store.dispatch(CREATE_NEW_TASK, {
    description: task_name,
    id: new Date().getTime(),
    project,
  });
};

const startTimer = async (time: number): Promise<void> => {
  const project = projects.value.find(project => project.id === project_id.value);
  const task_name = description.value;

  description.value = '';
  project_id.value = null;

  playRequestPending.value = true;
  await store.dispatch(CREATE_NEW_TASK, {
    description: task_name,
    time_spent: time,
    id: new Date().getTime(),
    project,
  });

  playRequestPending.value = false;
};

watch(active_task, (state, prev_state) => {
  if (state.id && state.id !== prev_state.id) {
    description.value = active_task.value.description;
    if (state.project?.id) {
      project_id.value = state.project.id;
    }

    if (prev_state?.endAt) {
      store.dispatch(FINISH_TASK_SESSION, prev_state);
    }
  }

  if (! state.id) {
    description.value = '';
    project_id.value = null;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DSTextField, {
        modelValue: description.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((description).value = $event)),
        placeholder: "Which task would you like to start?",
        icon: "task_alt",
        autofocus: _ctx.$q.screen.gt.xs,
        "aria-label": "Task description"
      }, null, 8, ["modelValue", "autofocus"]),
      _createVNode(DSSelect, {
        modelValue: project_id.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((project_id).value = $event)),
        options: parsedProjects.value,
        label: "Select a project",
        icon: "folder",
        clearable: "",
        "aria-label": "Select project"
      }, null, 8, ["modelValue", "options"])
    ]),
    _createVNode(Timer, {
      "task-name": description.value,
      "play-request-pending": playRequestPending.value,
      "stop-request-pending": stopRequestPending.value,
      onTimeIsFinished: finishTask,
      onStartTimer: startTimer
    }, null, 8, ["task-name", "play-request-pending", "stop-request-pending"])
  ]))
}
}

})